"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipRecipe = void 0;
function skipRecipe(skipWhile) {
    return function (n) {
        let counter = n;
        return skipWhile.call(this, () => counter-- > 0);
    };
}
exports.skipRecipe = skipRecipe;
